import React from 'react';
import { Typography } from 'antd';
import { components } from '@seaoil/component-lib';
import { LayoutWithNav } from '../components/Layout';

const { Text } = Typography;
const { Auth } = components;

function WorkflowPage() {
  return (
    <Auth.PrivateComponent redirect="/login">
      <LayoutWithNav>
        <Text>Please select a workflow from the menu.</Text>
      </LayoutWithNav>
    </Auth.PrivateComponent>
  );
}

export default WorkflowPage;
